import { render, staticRenderFns } from "./mortgage-status.vue?vue&type=template&id=1cd9eb24&scoped=true"
import script from "./mortgage-status.vue?vue&type=script&lang=ts"
export * from "./mortgage-status.vue?vue&type=script&lang=ts"
import style0 from "./mortgage-status.vue?vue&type=style&index=0&id=1cd9eb24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd9eb24",
  null
  
)

export default component.exports